import { createApi } from '@reduxjs/toolkit/query/react';

import fetchBaseQuery from '../fetchBaseQuery';

export type GetTeamPreferenceRequest = {
    name: string;
    teamId: string;
};

export type GetTeamPreferenceResponse = {
    value: string;
    createdAt: number; // timestamp
    expiresAfter: number; // timestamp
    expired: boolean;
    userId: number;
};

export type UpdateTeamPreferenceRequest = {
    name: string;
    teamId: string;
    value: string;
};

/**
 * Preferences API spec - https://lokalise.atlassian.net/l/cp/LegmCs6m
 */
const preferencesApi = createApi({
    reducerPath: 'preferences',
    baseQuery: fetchBaseQuery(),
    tagTypes: [],
    endpoints: (builder) => ({
        /**
         * Returns 404 in case there is no preference yet.
         */
        getTeamPreference: builder.query<GetTeamPreferenceResponse, GetTeamPreferenceRequest>({
            query: ({ name, teamId }) => ({
                method: 'GET',
                url: `/preferences/${name}/scopes/team:${teamId}`,
            }),
        }),
        updateTeamPreference: builder.mutation<void, UpdateTeamPreferenceRequest>({
            query: ({ name, teamId, value }) => ({
                method: 'PATCH',
                url: `/preferences/${name}/scopes/team:${teamId}`,
                body: { value },
            }),
        }),
    }),
});

export default preferencesApi;

export const { useGetTeamPreferenceQuery, useLazyGetTeamPreferenceQuery, useUpdateTeamPreferenceMutation } =
    preferencesApi;
